export enum FluidsConstants {
  SET_TRANSPORT_TYPE = 'fluids/SET_TRANSPORT_TYPE',
  SET_BEFORE_INTAKE_CRYS = 'fluids/SET_BEFORE_INTAKE_CRYS',
  SET_BEFORE_INTAKE_COLL = 'fluids/SET_BEFORE_INTAKE_COLL',
  SET_BEFORE_INTAKE_OTHER = 'fluids/SET_BEFORE_INTAKE_OTHER',
  SET_BEFORE_INTAKE_CUSTOM = 'fluids/SET_BEFORE_INTAKE_CUSTOM',
  SET_BEFORE_INTAKE_FEEDINGS = 'fluids/SET_BEFORE_INTAKE_FEEDINGS',
  SET_BEFORE_OUTPUT_EBL = 'fluids/SET_BEFORE_OUTPUT_EBL',
  SET_BEFORE_OUTPUT_UO = 'fluids/SET_BEFORE_OUTPUT_UO',
  SET_BEFORE_OUTPUT_OTHER = 'fluids/SET_BEFORE_OUTPUT_OTHER',
  SET_BEFORE_OUTPUT_CUSTOM = 'fluids/SET_BEFORE_OUTPUT_CUSTOM',
  SET_BEFORE_OUTPUT_BM = 'fluids/SET_BEFORE_OUTPUT_BM',
  SET_DURING_INTAKE_CRYS = 'fluids/SET_DURING_INTAKE_CRYS',
  SET_DURING_INTAKE_COLL = 'fluids/SET_DURING_INTAKE_COLL',
  SET_DURING_INTAKE_OTHER = 'fluids/SET_DURING_INTAKE_OTHER',
  SET_DURING_INTAKE_CUSTOM = 'fluids/SET_DURING_INTAKE_CUSTOM',
  SET_DURING_INTAKE_FEEDINGS = 'fluids/SET_DURING_INTAKE_FEEDINGS',
  SET_DURING_OUTPUT_EBL = 'fluids/SET_DURING_OUTPUT_EBL',
  SET_DURING_OUTPUT_UO = 'fluids/SET_DURING_OUTPUT_UO',
  SET_DURING_OUTPUT_OTHER = 'fluids/SET_DURING_OUTPUT_OTHER',
  SET_DURING_OUTPUT_CUSTOM = 'fluids/SET_DURING_OUTPUT_CUSTOM',
  SET_DURING_OUTPUT_BM = 'fluids/SET_DURING_OUTPUT_BM',
  SET_IS_NEONATAL = 'fluids/SET_IS_NEONATAL',
  CALCULATE_IS_NEONATAL = 'fluids/CALCULATE_IS_NEONATAL',
  SAVE_FLUIDS = 'fluids/SAVE_FLUIDS',
  SET_FLUIDS_STATE = 'fluids/SET_FLUIDS_STATE',
  RESET_FLUIDS_STATE = 'fluids/RESET_FLUIDS_STATE',
  CLEAR_FLUIDS_FIELDS = 'fluids/CLEAR_FLUIDS_FIELDS',
  SET_CUSTOM_FLUID_VALUE = 'fluids/SET_CUSTOM_FLUID_VALUE',
  SET_CUSTOM_FLUIDS = 'fluids/SET_CUSTOM_FLUIDS',
}
